class AddBeneficiary {
    id;
    name;
    birthdate;
    relationship;
    percentage;
    isVerified;
    investor;
    createdAt;
    updatedAt;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.birthdate = data.birthdate;
        this.relationship = data.relationship;
        this.percentage = data.percentage;
        this.isVerified = data.isVerified;
        this.investor = data.investor;
        this.createdAt = new Date(data.createdAt);
        this.updatedAt = new Date(data.updatedAt);
    }
}
export default AddBeneficiary;
